import type React from 'react';

interface ScoreProps {
  value?: number;
}

function Score({
  value = undefined,
}: ScoreProps): React.JSX.Element | null {
  if (value === undefined) return null;
  return (
    <div className="Score">
      {Math.floor(value * 100)}
      %
    </div>
  );
}

export { Score };
